import { useLingui } from '@lingui/react/macro';
import { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';
import { formatCountdown, remainingSeconds } from './request-countdown';

const TICK_MS = 250;

export const useRemainingSeconds = (expiresAt: number) => {
	const [seconds, setSeconds] = useState(() => remainingSeconds({ expiresAt }));

	useEffect(() => {
		setSeconds(remainingSeconds({ expiresAt }));
		const timer = setInterval(() => {
			const next = remainingSeconds({ expiresAt });
			setSeconds(next);
			if (next === 0) clearInterval(timer);
		}, TICK_MS);
		return () => clearInterval(timer);
	}, [expiresAt]);

	return seconds;
};

type RequestCountdownProps = {
	expiresAt: number;
	className?: string;
};

export const RequestCountdown = ({ expiresAt, className }: RequestCountdownProps) => {
	const { t } = useLingui();
	const time = formatCountdown(useRemainingSeconds(expiresAt));

	return (
		<p data-testid="request-countdown" className={cn('text-sm text-muted-foreground tabular-nums', className)}>
			{t`Expires in ${time}`}
		</p>
	);
};
